import { useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link, useSearchParams } from 'react-router-dom'
import { useFormik } from 'formik'
import { resetPassword, userInfo } from '../core/_requests'
import toast from 'react-hot-toast'
import { useAuth } from '..'

export function ResetPassword() {
  const [loading, setLoading] = useState(false)
  const [searchParams] = useSearchParams('');
  const { saveAuth, setCurrentUser, logout } = useAuth()
  const tokenParam = searchParams.get('token') ?? '';
  const emailParam = searchParams.get('email') ?? '';

  const initialValues = {
    email: emailParam,
    password: ''
  }

  const ResetPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email('Wrong email format')
      .required('Email is required'),
    password: Yup.string()
      .min(6, 'Minimum 6 characters')
      .required('Password is required'),
  })

  const formik = useFormik({
    initialValues,
    validationSchema: ResetPasswordSchema,
    onSubmit: (values, { setSubmitting }) => {
      setLoading(true)
      setTimeout(() => {
        resetPassword(values?.email, values?.password, tokenParam)
          .then((res: any) => {
            setLoading(false)
            saveAuth(res?.data?.response)
            localStorage.setItem('auth_user', JSON.stringify(res?.data?.response))
            localStorage.setItem('token', res?.data?.response?.token)
            localStorage.setItem('entity_id', '1')

            userInfo(localStorage.getItem('entity_id'))
              .then((res: any) => {
                setCurrentUser(res?.data)
              })
              .catch((err: any) => {
                toast.error(err?.response?.data?.message)
                logout()
              })
          })
          .catch((error: any) => {
            toast.error(error?.response?.data?.message)
            setLoading(false) 
            setSubmitting(false)
            saveAuth(undefined)
            setCurrentUser(undefined)
          })
      }, 1000)
    },
  })

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_password_reset_form'
      onSubmit={formik.handleSubmit}
    >
      <div className='text-center mb-10'>
        <h1 className='text-gray-900 fw-bolder mb-3'>Reset Password</h1>
      </div>

      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-gray-900 fs-6'>Email</label>
        <input
          type='email'
          autoComplete='off'
          disabled
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            { 'is-invalid': formik.touched.email && formik.errors.email },
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>

      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-gray-900 fs-6'>Password</label>
        <input
          type='password'
          placeholder='*******'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control bg-transparent',
            { 'is-invalid': formik.touched.password && formik.errors.password },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>

      <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
        <button
          type='submit'
          id='kt_password_reset_submit'
          className='btn btn-primary me-4'
          disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Submit</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
        <Link to='/auth/login'>
          <button
            type='button'
            id='kt_login_password_reset_form_cancel_button'
            className='btn btn-light'
            disabled={formik.isSubmitting || !formik.isValid}
          >
            Cancel
          </button>
        </Link>{' '}
      </div>
    </form>
  )
}

export default ResetPassword